// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GroupPayMemberFieldsFragment = { __typename?: 'GroupPayMember', id: string, name: string, email: string, phone?: string | null };

export type UpdateGroupPayMemberMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateGroupPayMemberInput;
}>;


export type UpdateGroupPayMemberMutation = { __typename?: 'Mutation', updateGroupPayMember: { __typename?: 'GroupPayMember', id: string, name: string, email: string, phone?: string | null } };

export const GroupPayMemberFieldsFragmentDoc = gql`
    fragment GroupPayMemberFields on GroupPayMember {
  id
  name
  email
  phone
}
    `;
export const UpdateGroupPayMemberDocument = gql`
    mutation updateGroupPayMember($id: ID!, $input: UpdateGroupPayMemberInput!) {
  updateGroupPayMember(id: $id, input: $input) {
    ...GroupPayMemberFields
  }
}
    ${GroupPayMemberFieldsFragmentDoc}`;
export type UpdateGroupPayMemberMutationFn = Apollo.MutationFunction<UpdateGroupPayMemberMutation, UpdateGroupPayMemberMutationVariables>;

/**
 * __useUpdateGroupPayMemberMutation__
 *
 * To run a mutation, you first call `useUpdateGroupPayMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupPayMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupPayMemberMutation, { data, loading, error }] = useUpdateGroupPayMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupPayMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupPayMemberMutation, UpdateGroupPayMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupPayMemberMutation, UpdateGroupPayMemberMutationVariables>(UpdateGroupPayMemberDocument, options);
      }
export type UpdateGroupPayMemberMutationHookResult = ReturnType<typeof useUpdateGroupPayMemberMutation>;
export type UpdateGroupPayMemberMutationResult = Apollo.MutationResult<UpdateGroupPayMemberMutation>;
export type UpdateGroupPayMemberMutationOptions = Apollo.BaseMutationOptions<UpdateGroupPayMemberMutation, UpdateGroupPayMemberMutationVariables>;